import { Check, Play, Square } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { resolveAudioSource } from "../../services/premiumAudio.js";
const MAX_SELECTION = 3;
export default function NatureFavoritesPicker({ sounds = [], selectedIds = [], onChange }) {
  const [previewId, setPreviewId] = useState(null);
  const audioRef = useRef(null);
  const requestRef = useRef(0);
  const stopPreview = () => {
    requestRef.current += 1;
    try { audioRef.current?.pause(); if (audioRef.current) audioRef.current.currentTime = 0; } catch {}
    audioRef.current = null;
    setPreviewId(null);
  };
  useEffect(() => stopPreview, []);
  const toggleSelection = (id) => {
    if (selectedIds.includes(id)) return onChange?.(selectedIds.filter((value) => value !== id));
    if (selectedIds.length < MAX_SELECTION) onChange?.([...selectedIds, id]);
  };
  const togglePreview = async (sound) => {
    if (previewId === sound.id) return stopPreview();
    stopPreview();
    const request = ++requestRef.current;
    try {
      const source = await resolveAudioSource(sound.file);
      if (requestRef.current !== request) return;
      const audio = new Audio(source);
      audio.loop = true;
      audio.volume = 0.55;
      audioRef.current = audio;
      setPreviewId(sound.id);
      await audio.play();
      if (requestRef.current !== request) { audio.pause(); audio.currentTime = 0; }
    } catch {
      if (requestRef.current === request) stopPreview();
    }
  };
  return <div className="nature-picker">
    <div className="nature-picker__count" aria-live="polite">{selectedIds.length} sur {MAX_SELECTION}</div>
    <div className="nature-picker__grid">{sounds.map((sound) => {
      const selected = selectedIds.includes(sound.id);
      const disabled = !selected && selectedIds.length >= MAX_SELECTION;
      const previewing = previewId === sound.id;
      return <article key={sound.id} className="nature-picker__item" data-selected={selected} data-disabled={disabled}>
        <button type="button" className="nature-picker__select" onClick={() => toggleSelection(sound.id)} disabled={disabled} aria-pressed={selected} aria-label={`${selected ? "Retirer" : "Choisir"} ${sound.name}`}>
          <span className="nature-picker__visual" aria-hidden="true"><img src={sound.image} alt="" /></span>
          <span className="nature-picker__name">{sound.name}</span>
          <span className="nature-picker__check" aria-hidden="true">{selected && <Check size={16} strokeWidth={2.5} />}</span>
        </button>
        <button type="button" className="nature-picker__preview" onClick={() => togglePreview(sound)} aria-label={`${previewing ? "Arrêter" : "Écouter"} ${sound.name}`}>
          {previewing ? <Square size={13} /> : <Play size={13} />}<span>{previewing ? "Arrêter" : "Écouter"}</span>
        </button>
      </article>;
    })}</div>
  </div>;
}
